/**
 * Who the server lets do what, mirrored from server/src/routes. A button the
 * server will refuse is worse than no button, so screens check these first.
 */
export const ROLES = {
  // documents.js COUNTER: raise, issue and cancel delivery orders; raise invoices.
  COUNTER: ['tenant_admin', 'sales_counter', 'accounts'],
  // documents.js GODOWN: despatch against an order.
  GODOWN: ['tenant_admin', 'godown_operator'],
  // Release/reject batches, cancel credit notes, edit price lists and credit, decide approvals.
  ADMIN_ACCOUNTS: ['tenant_admin', 'accounts'],
  // batches.js CAN_RECORD: import batches, record specifications.
  RECORD_SPEC: ['tenant_admin', 'godown_operator', 'accounts'],
  // creditNotes.js CAN_RAISE.
  RAISE_CREDIT: ['tenant_admin', 'accounts', 'sales_counter'],
  // Price lists, price/credit checks and approvals are not shown to the godown.
  COMMERCIAL: ['tenant_admin', 'accounts', 'sales_counter'],
  TRANSFERS: ['tenant_admin', 'godown_operator', 'accounts'],
  ADMIN: ['tenant_admin'],
};

/** can(session, ROLES.COUNTER) or can('accounts', ROLES.COUNTER). */
export function can(sessionOrRole, roles) {
  const role = typeof sessionOrRole === 'string'
    ? sessionOrRole
    : sessionOrRole && sessionOrRole.user && sessionOrRole.user.role;
  return Boolean(role) && roles.includes(role);
}
